/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type CartRemoveItemLink_viewer$ref = any;
type ItemHeartWrapper_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type CartItem_viewer$ref: FragmentReference;
export type CartItem_viewer = {|
  +$fragmentRefs: CartRemoveItemLink_viewer$ref & ItemHeartWrapper_viewer$ref,
  +$refType: CartItem_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "CartItem_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "loadPortfolioData",
      "type": "Boolean!",
      "defaultValue": true
    },
    {
      "kind": "RootArgument",
      "name": "userIds",
      "type": null
    }
  ],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "CartRemoveItemLink_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "ItemHeartWrapper_viewer",
      "args": [
        {
          "kind": "Variable",
          "name": "loadPortfolioData",
          "variableName": "loadPortfolioData",
          "type": null
        },
        {
          "kind": "Variable",
          "name": "userIds",
          "variableName": "userIds",
          "type": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'a9eb695d6fbee9464bc38dbd58f4d19b';
module.exports = node;
